import React, { ReactNode } from "react";
import Icon from "../Icon";

export interface LearnMoreProps {
	href?: string;
	onClick?: () => void;
	className?: string;
	children?: ReactNode;
}

const LearnMore: React.FC<LearnMoreProps> = ({ href, onClick, className, children }) => {
	return (
		<a href={href} target="_blank" className={`learn-more ${className} text-decoration-none`} onClick={onClick}>
			{children ? children : "Learn More"} <Icon icon="arrow-right" />
		</a>
	);
};

export default LearnMore;
